var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReliability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.384,
    height: 50.226,
    viewBox: "0 0 47.384 50.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62761",
    "data-name": "Group 62761",
    transform: "translate(1.003 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107792",
    "data-name": "Path 107792",
    d: "M44.4,149.781H55.957s1.166,13,11.581,13c0,0,.037,6.924-.291,10.692-.333,3.826-3.277,21.309-22.215,24.385",
    transform: "translate(-22.161 -149.781)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107793",
    "data-name": "Path 107793",
    d: "M56.858,149.781H45.3s-1.166,13-11.581,13c0,0-.035,6.924.291,10.692.333,3.826,3.279,21.309,22.215,24.385",
    transform: "translate(-33.718 -149.781)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107796",
    "data-name": "Path 107796",
    d: "M43.827,165.334l6.762,5.066,8.925-12.129",
    transform: "translate(-27.869 -142.161)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliability);
export default __webpack_public_path__ + "static/media/reliability.bee1a0530ec0a78cf846e60f2bbcccde.svg";
export { ForwardRef as ReactComponent };